import { render, staticRenderFns } from "./Unitlist.vue?vue&type=template&id=95432c3e&scoped=true"
import script from "./Unitlist.vue?vue&type=script&lang=js"
export * from "./Unitlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95432c3e",
  null
  
)

export default component.exports